import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      icon: faGithub,
      url: 'https://github.com/Anayo-Anyafulu',
      label: 'GitHub'
    },
    {
      icon: faLinkedin,
      url: 'https://linkedin.com/in/anayoanyafulu',
      label: 'LinkedIn'
    },
  ];

  return (
    <footer className="bg-dark-900 border-t border-dark-700">
      <div className="container-max-width section-padding py-8">
        <div className="flex flex-col md:flex-row items-center justify-between">
          {/* Copyright */}
          <div className="text-center md:text-left mb-4 md:mb-0">
            <p className="text-dark-400">
              © {currentYear} Anayo Anyafulu. All rights reserved.
            </p>
          </div>

          {/* Social Links */}
          <div className="flex space-x-4">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-dark-400 hover:text-primary-400 transition-colors duration-300"
                aria-label={social.label}
              >
                <FontAwesomeIcon icon={social.icon} className="text-xl" />
              </a>
            ))}
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
